export default __webpack_public_path__ + "static/media/logo-app2g.f35dc6c0.svg";